export const logError = (
  message: string,
  ...optionalParams: unknown[]
): void => {
  if (process.env.NODE_ENV !== 'production') {
    console.error(message, ...optionalParams)
  }
}
